{
  "list": {
    "intro": "หน้าที่รวมสินค้าบนเว็บ เช่น \"Pokémon Rank A\" หรือ \"ของเข้าใหม่\"",
    "new": "สร้างคอลเลกชัน",
    "search": "ค้นคอลเลกชัน",
    "show_trash": "แสดงที่ลบแล้ว (30 วัน)",
    "empty": "ยังไม่มีคอลเลกชัน",
    "empty_hint": "สร้างโดยเลือกการ์ดเอง หรือใช้เงื่อนไข",
    "trash_empty": "ไม่มีรายการที่ลบใน 30 วันที่ผ่านมา",
    "label": "คอลเลกชัน",
    "type_manual": "เลือกเอง",
    "type_smart": "ตามเงื่อนไข",
    "count_one": "{{count}} รายการ",
    "count_other": "{{count}} รายการ",
    "published": "แสดงบนเว็บ",
    "hidden": "ซ่อนอยู่",
    "restore": "กู้คืน",
    "restored": "กู้คืน \"{{title}}\" แล้ว"
  },
  "new": {
    "title": "คอลเลกชันแบบไหน?",
    "hint": "เปลี่ยนสินค้าทีหลังได้ แต่เปลี่ยนแบบไม่ได้",
    "manual": "เลือกการ์ดเอง",
    "manual_hint": "ค้น เพิ่ม และเรียงการ์ดตามที่ต้องการ",
    "smart": "ตามเงื่อนไข",
    "smart_hint": "เช่น Pokémon · Rank A · ราคา ≥ ¥10,000 — การ์ดใหม่เข้ามาเอง"
  },
  "edit": {
    "new_manual": "คอลเลกชันใหม่ (เลือกเอง)",
    "new_smart": "คอลเลกชันใหม่ (ตามเงื่อนไข)",
    "untitled": "คอลเลกชัน",
    "manual_intro": "เพิ่มการ์ดแล้วลากเรียง ยังไม่ส่งอะไรจนกดบันทึก",
    "smart_intro": "สินค้าที่ตรงเงื่อนไขจะเข้ามาเอง ตัวเลขด้านล่างระบบเป็นคนนับ",
    "basics": "ชื่อและคำอธิบาย",
    "title_label": "ชื่อ",
    "title_required": "ตั้งชื่อคอลเลกชัน",
    "description_label": "คำอธิบาย",
    "description_hint": "แสดงบนสุดของหน้าคอลเลกชัน เว้นบรรทัดว่างเพื่อขึ้นย่อหน้าใหม่",
    "publish_now": "แสดงบนเว็บทันที",
    "products_title": "สินค้าและลำดับ",
    "rules_title": "เงื่อนไข",
    "sort_label": "ลำดับบนเว็บ",
    "sort_hint": "ลูกค้าเห็นสินค้าเรียงแบบไหน",
    "sort": {
      "manual": "ลำดับที่ตั้งเอง",
      "created_desc": "ใหม่สุดก่อน",
      "price_asc": "ถูกสุดก่อน",
      "price_desc": "แพงสุดก่อน",
      "title_asc": "ชื่อ A → Z",
      "title_desc": "ชื่อ Z → A",
      "best_selling": "ขายดีก่อน"
    },
    "pictures": "รูป",
    "hero_desktop": "รูปด้านบน (คอมพิวเตอร์)",
    "hero_mobile": "รูปด้านบน (มือถือ)",
    "languages": "ชื่อและคำอธิบายภาษาอื่น",
    "layout_label": "รูปแบบหน้า",
    "layout_hint": "เว้นว่างไว้ถ้าใช้แบบมาตรฐาน",
    "create": "สร้างคอลเลกชัน",
    "save": "บันทึก",
    "saved": "บันทึก \"{{title}}\" แล้ว",
    "show": "แสดงบนเว็บ",
    "hide": "ซ่อนจากเว็บ",
    "now_shown": "แสดงบนเว็บแล้ว",
    "now_hidden": "ซ่อนจากเว็บแล้ว",
    "delete": "ลบ",
    "delete_title": "ลบคอลเลกชันนี้?",
    "delete_consequence": "หน้านี้จะหายจากเว็บ สินค้ายังอยู่ กู้คืนได้ภายใน 30 วัน",
    "deleted": "ลบคอลเลกชันแล้ว"
  },
  "manual": {
    "add_label": "เพิ่มสินค้า",
    "search_placeholder": "ชื่อ รหัสสินค้า หรือเลข cert",
    "results": "ผลการค้น",
    "no_results": "ไม่พบ",
    "add": "เพิ่ม",
    "add_named": "เพิ่ม {{title}}",
    "inside": "เพิ่มแล้ว",
    "empty": "ยังไม่มีสินค้า — ค้นด้านบนแล้วกดเพิ่ม",
    "order_hint": "ลาก ⠿ กดปุ่ม ▲ ▼ หรือกด Space เพื่อยกแล้วใช้ลูกศรเลื่อน",
    "list_label": "สินค้าในคอลเลกชันนี้",
    "remove": "เอา {{title}} ออก",
    "removed": "เอา \"{{title}}\" ออกแล้ว",
    "loading": "กำลังโหลด…"
  },
  "rules": {
    "match_legend": "สินค้าต้องตรงกับ",
    "match": {
      "all": "ทุกเงื่อนไข",
      "any": "เงื่อนไขใดก็ได้"
    },
    "list_label": "เงื่อนไข",
    "row_label": "เงื่อนไข {{n}}",
    "field_label": "อะไร (เงื่อนไข {{n}})",
    "op_label": "อย่างไร (เงื่อนไข {{n}})",
    "pick_field": "เลือก…",
    "remove": "ลบเงื่อนไข {{n}}",
    "add": "เพิ่มเงื่อนไข",
    "and": "ถึง",
    "from": "ตั้งแต่",
    "to": "ถึง",
    "relative": "ภายใน … วันที่ผ่านมา",
    "days_placeholder": "จำนวนวัน",
    "set_placeholder": "รหัสชุด เช่น SV2a",
    "list_placeholder": "คั่นด้วยจุลภาค",
    "attribute": "ข้อมูลเพิ่มเติม: {{name}}",
    "fields": {
      "game": "เกม",
      "set": "ชุด",
      "product_type": "ประเภท",
      "raw_rank": "Rank (A–D การ์ด)",
      "grading_company": "บริษัทเกรด",
      "grade": "เกรด (การ์ดเกรด)",
      "price": "ราคา (¥ รวมภาษี)",
      "tag": "แท็ก",
      "category": "หมวด",
      "vendor": "ผู้ผลิต",
      "rarity": "ความหายาก",
      "language": "ภาษาการ์ด",
      "availability": "มีของ",
      "status": "สถานะ",
      "created_at": "วันที่ลง",
      "published_at": "วันที่เริ่มขาย",
      "consignor": "ของฝากขาย",
      "title": "ชื่อ",
      "condition_type": "การ์ด/เกรด/ซีล",
      "compare_at_status": "ตรวจราคาอ้างอิงแล้ว"
    },
    "ops": {
      "eq": "คือ",
      "neq": "ไม่ใช่",
      "in": "เป็นหนึ่งใน",
      "not_in": "ไม่ใช่ทั้งหมดนี้",
      "contains": "มีคำว่า",
      "starts_with": "ขึ้นต้นด้วย",
      "gt": "มากกว่า",
      "gte": "อย่างน้อย",
      "lt": "น้อยกว่า",
      "lte": "ไม่เกิน",
      "between": "ระหว่าง",
      "is_true": "ใช่",
      "is_false": "ไม่ใช่"
    },
    "ops_date": {
      "gt": "หลัง",
      "gte": "ตั้งแต่",
      "lt": "ก่อน",
      "lte": "จนถึง"
    },
    "ops_availability": {
      "is_true": "มีของ",
      "is_false": "ขายหมด"
    },
    "ops_consignor": {
      "is_true": "เป็นของฝากขาย",
      "is_false": "เป็นของร้าน"
    },
    "status": {
      "active": "ขายอยู่",
      "draft": "ร่าง",
      "archived": "เก็บถาวร"
    },
    "condition": {
      "raw": "การ์ด",
      "graded": "การ์ดเกรด",
      "sealed": "ซีล"
    },
    "compare_at": {
      "verified": "ตรวจแล้ว",
      "unverified": "ยังไม่ตรวจ"
    },
    "problem": {
      "field_required": "เลือกว่าจะดูอะไร",
      "operator_required": "เลือกว่าจะดูอย่างไร",
      "value_required": "กรอกค่า",
      "value_invalid": "ค่านี้ใช้ไม่ได้ — ตรวจอีกครั้ง",
      "invalid": "ระบบใช้เงื่อนไขนี้ไม่ได้ — ตรวจอีกครั้ง",
      "unknown_field": "เงื่อนไขแบบนี้ยังไม่มี",
      "operator_not_allowed": "\"อย่างไร\" นี้ไม่เข้ากับ \"อะไร\"",
      "field_not_enabled": "ยังใช้ไม่ได้"
    }
  },
  "preview": {
    "title": "สินค้าที่ตรงตอนนี้",
    "waiting": "กรอกเงื่อนไขให้ครบเพื่อดูจำนวน",
    "counting": "กำลังนับ…",
    "count_one": "ตรง {{count}} รายการ",
    "count_other": "ตรง {{count}} รายการ",
    "error": "นับไม่ได้ ลองอีกครั้ง",
    "fix_rows": "มีเงื่อนไขที่ต้องแก้ (ขีดสีแดง)"
  }
}
